export class InternalServerError extends Error {
    public constructor(message = 'INTERNAL_SERVER_ERROR') {
        super(message);
    }
}
